import {
  Button,
  PageHeader,
  Space,
  Table,
  Form,
  Input,
  Col,
  Typography,
  Row,
  Select,
  Modal,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  TeamOutlined,
  RetweetOutlined,
  SnippetsOutlined,
  ReloadOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import { useApiContext } from "../../hooks/useApiContext";
import apis from "../../services/apis";

export default function EmployeesList() {
  const { confirm } = Modal;
  const { employeedispatch, employee, projectdispatch, projects, user } =
    useApiContext();
  const [employeeData, setEmployeeData] = useState([]);
  const navigate = useNavigate();
  const { Column } = Table;
  useEffect(() => {
    if (employee.length < 1) apis.Employees.list(employeedispatch);
    if (projects.length < 1) apis.Projects.list(projectdispatch);
    setEmployeeData(employee);
  }, [employee.length < 1, projects.length < 1]);
  console.log("employees", employee);

  const getsearchData = (value) => {
    //console.log("search value", value.target.value)
    if (value.target.value === null) setEmployeeData(employee);

    var getData = employee.filter((x) => x.fullName.toLowerCase().includes(value.target.value.toLowerCase()));
    setEmployeeData(getData);
  };
  const getsearchDataByEmpId = (value) => {
    //console.log("search value", value.target.value)
    if (value.target.value === null) setEmployeeData(employee);

    var getData = employee.filter((x) => x.empId.toLowerCase().includes(value.target.value.toLowerCase()));
    setEmployeeData(getData);
  };
  var getEmployeesData = () => {
    setEmployeeData(employee);
  };

  var handleSearchByProject = (value) => {
    var getData = employee.filter((x) => x.projectId == value);
    setEmployeeData(getData);
  };

  const confirmDelete = (id) => {
    console.log("expense id", id);
    confirm({
      title: "Are you sure you want to delete this item?",
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      okType: "danger",
      closable: true,
      async onOk() {
        //this.cancelButtonProps={disabled:true}
        try {
          return await new Promise((resolve, reject) => {
            apis.Employees.delete(employeedispatch, id)
              .then((res) => {
                resolve("Resolved");
              })
              .catch(() => reject("unable to delete"));
          });
        } catch {
          return await message.error("unable to delete");
        }
      },
    });
  };
  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Employees List"
        subTitle="Find all the list of employees here"
        extra={[
          <Button
            type="primary"
            onClick={() => getEmployeesData()}
            icon={<ReloadOutlined />}
          >
            Refresh
          </Button>,
          <Button
            type="primary"
            onClick={() => navigate("/addemployee")}
            icon={<TeamOutlined />}
          >
            Add Employee
          </Button>,
        ]}
      />
      {employeeData && (
        <>
          <Typography.Title level={4}>Filters</Typography.Title>
          <Row>
            <Col span={6}>
              <Form.Item label="Enter Employee Name">
                <Input
                  placeholder="Enter employee full-name here"
                  onKeyUp={(e) => getsearchData(e)}
                />
              </Form.Item>
            </Col>
            <Col span={6} style={{ marginLeft: "10px"}}>
              <Form.Item label="Enter Employee Id">
                <Input
                  placeholder="Enter employee id here"
                  onKeyUp={(e) => getsearchDataByEmpId(e)}
                />
              </Form.Item>
            </Col>
            <Col span={6} style={{ marginLeft: "10px", marginTop: "30px" }}>
              <Form.Item label="Search by Project" style={{ width: "100%" }}>
                <div style={{ width: "100% !important" }}>
                  <Select
                    dropdownMatchSelectWidth
                    onChange={handleSearchByProject}
                    style={{ width: "100% !important" }}
                    allowClear
                    showSearch
                    placeholder="Select Project"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                  >
                    {projects &&
                      projects.map((item) => (
                        <Select.Option value={item.id}>
                          {item.projectName}
                        </Select.Option>
                      ))}
                  </Select>
                </div>
              </Form.Item>
            </Col>
          </Row>
          <Table dataSource={employeeData} rowKey={(r) => r.id} >
            <Column title="Employee Name" dataIndex="fullName" key="id"/>
            <Column title="Reference Id" dataIndex="empId" key="id" />
            <Column
              title="Border Number"
              dataIndex="borderNumber"
              key="id"
              render={(text, record) => (
                <>
                  {record.borderNumber === "string"
                    ? "Not Mentioned"
                    : record.borderNumber}
                </>
              )}
            />
            <Column
              title="Project"
              key="id"
              render={(text, record) => <>{record.project?.projectName}</>}
            />

            <Column
              title="Action"
              key="id"
              render={(text, record) => (
                <Space size="middle">
                  {user.role == "admin" && (
                    <Button type="link" icon={<RetweetOutlined />} size="small">
                      <Link to={`/employeeEdit/${record.id}`}> Edit</Link>
                    </Button>
                  )}

                  <Button type="link" icon={<SnippetsOutlined />} size="small">
                    <Link to={`/employeeDetails/${record.id}`}>
                      View Details
                    </Link>
                  </Button>

                  {user.role == "admin" && (
                    <Button
                      type="link"
                      danger
                      icon={<DeleteOutlined />}
                      onClick={() => confirmDelete(record.id)}
                      size="small"
                    >
                      Delete
                    </Button>
                  )}
                </Space>
              )}
            />
          </Table>
        </>
      )}
    </>
  );
}
